export default __webpack_public_path__ + "static/media/inicia_sesion.8c3acbb3.jpg";